import { React, useEffect, useState } from "react";
import axios from "axios";
import './MySubscription.scss'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BillingInfo from "./BillingInfo/BillingInfo";
import Invoices from "../Invoices/Invoices";


function MySubscription() {
  const [priceActive, setPriceActive] = useState("");
  const [planActive, setPlanActive] = useState("");
  const [currentStripePriceId, setCurrentStripePriceId] = useState("");
  const [productName, setProductName] = useState("");
  const [teamMember, setTeamMember] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [currentPeriodEnd, setCurrentPeriodEnd] = useState("");
  const [invoiceList, setInvoiceList] = useState([]);
  const [, setIsLoading] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedLast, setSelectedLast] = useState("");
  const [activeSubcriptionrefresh, SetActiveSubscriptionrefresh] = useState(false);
  const [purchaseTeamMembers, setPurchaseTeamMembers] = useState("");
  const [isComplementary, setIsComplementary] = useState(false);
  const [userCredits, setUserCredits] = useState(null);

  useEffect(() => {
    const findObjectById = (array, id) => {
      return array.find(obj => obj.plan.product.id === id);
    };

    const findObjectByProductId = (array, id) => {
      return array.find(obj => obj.id === id);
    };

    const token = localStorage.getItem("token");
    const fetchActiveSubscription = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}subscriptions/active-subscriptions`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        let subPlanName = "";
        if (response.data.data.subscription) {
          let subscription = response.data.data.subscription;
          const plan = subscription.plan || subscription.productDetails || {};

          subPlanName = plan.displayName || plan.name || "";
          setProductName(subPlanName);
          setCurrentStripePriceId(plan.stripePriceId || "");
          setCurrentPeriodEnd(subscription.current_period_end || subscription.updatedAt);
          // price in new response is in dollars, so multiply by 100 to keep compatibility with BillingInfo
          setPriceActive((plan.price || 0) * 100);
          setPlanActive(plan.interval || plan.subscriptionType || "");
        } else if (response.data.data.subscriptions) {
          let productList = findObjectById(response.data.data.subscriptions, `${process.env.REACT_APP_MAIN_PLAN_ID}`);
          if (productList) {
            subPlanName = productList.plan.product.name;
            setProductName(subPlanName);
            setCurrentStripePriceId(productList.items.data[0].plan.id);
            setCurrentPeriodEnd(productList.current_period_end);
            setPriceActive(productList.items.data[0].plan.amount);
            setPlanActive(productList.items.data[0].plan.interval);
          }
        }

        if (response.data.data.totalAvailableSeats !== undefined) {
          setPurchaseTeamMembers(response.data.data.totalAvailableSeats);
        }

        const hasActiveSubscription = !!response.data.data.subscription || 
          (response.data.data.subscriptions && findObjectById(response.data.data.subscriptions, `${process.env.REACT_APP_MAIN_PLAN_ID}`));

        if (response.data.data.userDetails) {
          const userComplementary = !!response.data.data.userDetails.isComplementary;

          // Priority: Subscribed plan > Complementary
          // If the user has an active subscription, we ignore the isComplementary flag for UI purposes
          const shouldShowAsComplementary = userComplementary && !hasActiveSubscription;

          setIsComplementary(shouldShowAsComplementary);
          if (shouldShowAsComplementary) {
            setPlanActive('Lifetime Promo');
            if (!subPlanName) setProductName("Complementary Plan");
          }
        }
        if (response.data.data.userCredits) {
          setUserCredits(response.data.data.userCredits);
        }
        if (response.data.data.paymentMethods) {
          setPaymentMethod(response.data.data.paymentMethods);
          const paymentDefault = response.data.data.paymentMethods.find(item => item?.isDefault);
          if (paymentDefault) {
            setSelectedTag(paymentDefault.id);
            setSelectedBrand(paymentDefault.card.brand);
            setSelectedLast(paymentDefault.card.last4);
          } else {
            setSelectedTag(response.data.data.paymentMethods[0].id);
            setSelectedBrand(response.data.data.paymentMethods[0].card.brand);
            setSelectedLast(response.data.data.paymentMethods[0].card.last4);
          }
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchInvoices = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}subscriptions/invoices-list`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        setInvoiceList(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    const fetchPlans = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}plans/list`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        ); // Replace this with the actual API endpoint
        // setBuckets(response?.data?.data?.bucketList); // Assuming the API response is an array of bucket objects
        if (response) {
          // let teamMember = findObjectById(response.data.data.productList,`${process.env.REACT_APP_TEAM_MEMBER_PLAN_ID}`);
          // if(teamMember){
          //   setTeamMember(teamMember);
          // }
          let productList = findObjectByProductId(response?.data?.data?.productList, `${process.env.REACT_APP_TEAM_MEMBER_PLAN_ID}`);
          setTeamMember(productList.priceList[0].id);
        }
        setIsLoading(false);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    if (token) {
      fetchActiveSubscription();
      fetchPlans();
      fetchInvoices();
    }
  }, [activeSubcriptionrefresh]);

  const handleDeattachRefresh = async () => {
    SetActiveSubscriptionrefresh(!activeSubcriptionrefresh);
  }

  return (
    <div className="mysubscription-section">
      <div className="myprofile-content">My subscription</div>
      <div className="profile-tab">
        <Tabs>
          <TabList>
            <Tab>My Subscription</Tab>
            <Tab>Invoices</Tab>
          </TabList>
          <TabPanel>
            {
              planActive ? <BillingInfo priceActive={priceActive} planActive={planActive} currentStripePriceId={currentStripePriceId} paymentMethod={paymentMethod} currentPeriodEnd={currentPeriodEnd} teamMember={teamMember} purchaseTeamMembers={purchaseTeamMembers} selectedTag={selectedTag} selectedBrand={selectedBrand} selectedLast={selectedLast} productName={productName} handleDeattachRefresh={handleDeattachRefresh} isComplementary={isComplementary} userCredits={userCredits} /> : ""
            }


          </TabPanel>
          <TabPanel>
            <Invoices invoiceList={invoiceList} />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
}
export default MySubscription; 